import { Icons } from '@/assets/icons/icons';
import { IconButton } from '@/components/ui/IconButton';
import { XStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { MotionRow } from './motion-row';
import { fieldInput } from './styles';

export function ArgRow({
  value,
  onChange,
  onPickFolder,
  onRemove,
  placeholder = '--flag or value',
  danger,
}: {
  value: string;
  onChange: (v: string) => void;
  onPickFolder: () => void;
  onRemove: () => void;
  placeholder?: string;
  danger?: boolean;
}) {
  return (
    <MotionRow>
      <XStack className="items-center gap-1.5">
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          spellCheck={false}
          placeholder={placeholder}
          className={cn(fieldInput.row, 'flex-1', danger && 'border-danger-8')}
        />
        <IconButton
          icon={Icons.folder}
          variant="outline"
          size="md"
          tooltip="Pick a folder"
          onClick={onPickFolder}
        />
        <IconButton
          icon={Icons.trash}
          variant="outline"
          size="md"
          tooltip="Remove"
          onClick={onRemove}
        />
      </XStack>
    </MotionRow>
  );
}
